import { KForm, KTextField } from "kinnect-general";
import { VCheckbox } from "vuetify/lib";


export default KForm.extend( {
	name: "CarrierForm",

	props: {
		carrier: Object,

		redirect: {
			...KForm.options.props.redirect,
			default: () => [ "back", { name: "carriers" } ]
		}
	},

	data: () => ( {
		formFields: {
			name: null,
			requiresAddress: true
		},
		addresses: []
	} ),

	computed: {
		editing() {
			return Boolean( this.carrier );
		},

		formUrl() {
			return this.editing
				? `carriers/${this.carrier.id}`
				: "carriers";
		}
	},

	watch: {
		carrier: {
			handler( carrier ) {
				if ( carrier ) {
					Object.keys( this.formFields ).forEach( key => {
						if ( carrier.hasOwnProperty( key ) ) {
							this.formFields[key] = carrier[key];
						}
					} );
				}
			},
			immediate: true
		}
	},

	render() {
		return <KForm
			attrs={{
				...this.$props,
				action: this.formUrl,
				data: this.formFields,
				method: this.editing ? "put" : "post"
			}}
			on={this.$listeners}
		>
			<KTextField
				label="Name*"
				prependIcon="person"
				required
				vModel={this.formFields.name}
				validationName="name"
				validationRules="required"
			></KTextField>

			<VCheckbox
				color="accent"
				hideDetails
				label="Requires Address"
				ripple
				vModel={this.formFields.requiresAddress}
			></VCheckbox>
		</KForm>;
	}
} );
